<template>
  <b-modal id="modal-delete-default" centered class="modal-delete-default" :no-enforce-focus="true">
    <div class="modal-delete-default-itens">
      <div class="modal-delete-default-itens-header">
        <button class="modal-delete-default-itens-close" @click="$bvModal.hide('modal-delete-default')">
          <div class="modal-delete-default-itens-close--icon">
            <img class="img-fluid" src="@/assets/img/close-modal.png" alt="icon close" title="icon close"/>
          </div>
        </button>
      </div>
      <div class="modal-delete-default-itens-body">
        <div class="modal-delete-default--header">
          <h2>Tem certeza que deseja excluir a Categoria?</h2>
        </div>
        <div class="modal-delete-default-btns">
          <button class="btn-green" @click="deleteDataDefault(false)">
            Não
          </button>
          <button class="btn-yes" @click="deleteDataDefault(true)">
            Sim
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['modalCategory']),
  },
  methods: {
    ...mapActions('Blog', ['removeCategoryBlog']),
    ...mapActions('Ebooks', ['removeCategoryEbooks']),
    ...mapActions('Plans', ['removeCategoryPlans']),
    ...mapActions('Meditation', ['removeCategoryMeditation']),
    async deleteDataDefault(data) {
      if (!data) {
        this.$bvModal.hide('modal-delete-default');
        return;
      }

      let id = this.modalCategory.data.id;

      if (this.modalCategory.isType === 'Blog') {
        await this.removeCategoryBlog(id);
      }
      else if (this.modalCategory.isType === 'Ebooks') {
        await this.removeCategoryEbooks(id);
      }
      else if (this.modalCategory.isType === 'Plans') {
        await this.removeCategoryPlans(id);
      }
      else if (this.modalCategory.isType === 'Meditation') {
        await this.removeCategoryMeditation(id);
      }
      this.$bvModal.hide('modal-delete-default');
    }
  }
}
</script>

<style lang="scss">
#modal-delete-default {
	.modal-header, .modal-footer {
		display: none;
	}
	.modal-content {
		box-shadow: 0px 3px 16px rgba(0,0,0,0.16);
		border: 0;
    border-radius: 20px;
	}
	.modal-body {
		padding: 0;
	}
}
.modal-delete-default {
	&-itens {
		&-close {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 10px;
      border: 0;
      background: 0;
      transition: 500ms;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.8;
      }
		}
    &-body {
      padding: 25px 20px 30px 20px;
      .modal-delete-default {
        &--header {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          text-align: center;
          margin-bottom: 30px;
          h2 {
            font-size: 20px;
            font-family: 'Font Semibold';
            color: var(--black);

            margin-bottom: 0;
          }
        }
        &-btns {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 50px;
          .btn-green {
            width: calc(50% - 7.5px);
            padding: 0;
            margin: 0;
            transition: 500ms;
            &:hover,&:focus {
              cursor: pointer;
              opacity: 0.8;
            }
          }
          .btn-yes {
            width: calc(50% - 7.5px);
            height: 50px;
            background: var(--white);
            border: 1px solid var(--gray-1);
            border-radius: 30px;
            font-size: 20px;
            font-family: 'Font Bold';
            color: var(--gray-2);
            text-transform: uppercase;
            padding: 0;
            transition: 500ms;
            &:hover,&:focus {
              cursor: pointer;
              opacity: 0.8;
            }
          }
        }
      }
    }
	}
}
</style>
